import React, {
  MouseEventHandler,
  FocusEventHandler,
  ReactNode,
  KeyboardEvent,
  KeyboardEventHandler,
  useState,
  forwardRef,
} from "react";
import { isEmpty, mobileFormat, numberForamt } from "bodycodi/cmap/app/js/common";

import Timer from "bodycodi/cmap/app/components/common/timer";

import errorIng from "bodycodi/cmap/app/img/error-1010.png";
import succesImg from "bodycodi/cmap/app/img/good-1010.png";
import icon_eye_on from "bodycodi/cmap/app/svg/icon_eye_on.svg";
import icon_eye_off from "bodycodi/cmap/app/svg/icon_eye_off.svg";

type InputProp = {
  type: string;
  name: string;
  placeholder: string;
  title: string;
  onClick?: MouseEventHandler<HTMLInputElement> | undefined;
  onBlur?: FocusEventHandler<HTMLInputElement> | undefined;
  children?: ReactNode;
  setEnd?: Function;
  refresh?: number;
  stop?: boolean;
  text?: string;
  errorText?: string;
  succesText?: string;
  number?: boolean;
  sms?: boolean;
  onKeyUp?: KeyboardEventHandler<HTMLInputElement>;
};

export const Input = forwardRef(
  (
    { type, name, placeholder, title, onClick, onBlur, errorText, succesText }: InputProp,
    ref: any
  ) => {
    const [isVisible, setIsVisible] = useState<boolean>(false);

    return (
      <div className="cmap1010-input">
        <div className="title">{title}</div>
        <div
          className={
            "input-wrap" +
            (!isEmpty(errorText) ? " error" : "") +
            (!isEmpty(succesText) ? " succes" : "")
          }
        >
          <div className="input">
            <input
              ref={ref}
              type={isVisible ? "text" : type}
              name={name}
              placeholder={placeholder}
              {...(!isEmpty(onClick) && { onClick: onClick })}
              {...(!isEmpty(onBlur) && { onBlur: onBlur })}
            />
          </div>
          {type === "password" && (
            <div className="eye-icon" onClick={() => setIsVisible(!isVisible)}>
              <img src={isVisible ? icon_eye_on : icon_eye_off} />
            </div>
          )}
        </div>
        <div className={"error-wrap" + (!isEmpty(errorText) ? " active" : "")}>
          <div className="error">
            <img src={errorIng} />
            <span>{errorText}</span>
          </div>
        </div>
        <div className={"succes-wrap" + (!isEmpty(succesText) ? " active" : "")}>
          <div className="succes">
            <img src={succesImg} />
            <span>{succesText}</span>
          </div>
        </div>
      </div>
    );
  }
);
Input.displayName = "Input";

export const InputWithCheck = ({
  type,
  name,
  placeholder,
  title,
  onClick,
  onBlur,
  children,
  text,
  errorText,
  succesText,
}: InputProp) => {
  return (
    <div className="cmap1010-input">
      <div className="title">{title}</div>
      <div
        className={
          "input-wrap" +
          (!isEmpty(errorText) ? " error" : "") +
          (!isEmpty(succesText) ? " succes" : "")
        }
      >
        <div className="input">
          {isEmpty(text) && (
            <input
              type={type}
              name={name}
              placeholder={placeholder}
              {...(!isEmpty(onClick) && { onClick: onClick })}
              {...(!isEmpty(onBlur) && { onBlur: onBlur })}
            />
          )}
          {!isEmpty(text) && (
            <div className="text" {...(!isEmpty(onClick) && { onClick: onClick })}>
              {text}
            </div>
          )}
        </div>
        <ul className="check">{children}</ul>
      </div>
      <div className={"error-wrap" + (!isEmpty(errorText) ? " active" : "")}>
        <div className="error">
          <img src={errorIng} />
          <span>{errorText}</span>
        </div>
      </div>
      <div className={"succes-wrap" + (!isEmpty(succesText) ? " active" : "")}>
        <div className="succes">
          <img src={succesImg} />
          <span>{succesText}</span>
        </div>
      </div>
    </div>
  );
};

export const InputBtn = forwardRef(
  (
    { type, name, placeholder, title, onClick, onBlur, children, errorText, succesText }: InputProp,
    ref: any
  ) => {
    const format = (e: KeyboardEvent<HTMLInputElement>) => {
      const input = e.target as HTMLInputElement;
      if (name === "mobile") {
        input.value = mobileFormat(input.value);
      }
      if (input.dataset?.number === "true") {
        input.value = numberForamt(input.value);
      }
    };

    return (
      <div className="cmap1010-input">
        <div className="title">{title}</div>
        <div
          className={
            "input-wrap" +
            (!isEmpty(errorText) ? " error" : "") +
            (!isEmpty(succesText) ? " succes" : "")
          }
        >
          <div className="input">
            <input
              ref={ref}
              type={type}
              name={name}
              onKeyUp={format}
              placeholder={placeholder}
              {...(!isEmpty(onClick) && { onClick: onClick })}
              {...(!isEmpty(onBlur) && { onBlur: onBlur })}
            />
          </div>
          {children}
        </div>
        <div className={"error-wrap" + (!isEmpty(errorText) ? " active" : "")}>
          <div className="error">
            <img src={errorIng} />
            <span>{errorText}</span>
          </div>
        </div>
        <div className={"succes-wrap" + (!isEmpty(succesText) ? " active" : "")}>
          <div className="succes">
            <img src={succesImg} />
            <span>{succesText}</span>
          </div>
        </div>
      </div>
    );
  }
);
InputBtn.displayName = "InputBtn";

export const InputWithTimer = ({
  type,
  name,
  placeholder,
  title,
  onClick,
  onBlur,
  onKeyUp,
  children,
  setEnd,
  refresh,
  stop,
  errorText,
  succesText,
  number = true,
  sms = true,
}: InputProp) => {
  return (
    <div className="cmap1010-input">
      <div className="title">{title}</div>
      <div
        className={
          "input-wrap" +
          (!isEmpty(errorText) ? " error" : "") +
          (!isEmpty(succesText) ? " succes" : "")
        }
      >
        <div className="input">
          <input
            type={type}
            name={name}
            placeholder={placeholder}
            maxLength={6}
            onKeyUp={onKeyUp}
            {...(number && { "data-number": true })}
            {...(sms && { autoComplete: "one-time-code" })}
            {...(!isEmpty(onClick) && { onClick: onClick })}
            {...(!isEmpty(onBlur) && { onBlur: onBlur })}
          />
        </div>
        <Timer setEnd={setEnd} stop={stop} refresh={refresh} />
        {children}
      </div>
      <div className={"error-wrap" + (!isEmpty(errorText) ? " active" : "")}>
        <div className="error">
          <img src={errorIng} />
          <span>{errorText}</span>
        </div>
      </div>
      <div className={"succes-wrap" + (!isEmpty(succesText) ? " active" : "")}>
        <div className="succes">
          <img src={succesImg} />
          <span>{succesText}</span>
        </div>
      </div>
    </div>
  );
};

export const InputLogin = ({
  type,
  name,
  placeholder,
  title,
  onClick,
  onBlur,
  errorText,
  succesText,
}: InputProp) => {
  const [isVisible, setIsVisible] = useState<boolean>(false);

  return (
    <div className="cmap1010-input">
      <div className="title">{title}</div>
      <div
        className={
          "input-wrap" +
          (!isEmpty(errorText) ? " error" : "") +
          (!isEmpty(succesText) ? " succes" : "")
        }
      >
        <div className="input">
          <input
            type={isVisible ? "text" : type}
            name={name}
            placeholder={placeholder}
            {...(!isEmpty(onClick) && { onClick: onClick })}
            {...(!isEmpty(onBlur) && { onBlur: onBlur })}
          />
        </div>
        {type === "password" && (
          <div className="eye-icon" onClick={() => setIsVisible(!isVisible)}>
            <img src={isVisible ? icon_eye_on : icon_eye_off} />
          </div>
        )}
      </div>
      <div className={"error-wrap" + (!isEmpty(errorText) ? " active" : "")}>
        <div className="error">
          <img src={errorIng} />
          <span>{errorText}</span>
        </div>
      </div>
      <div className={"succes-wrap" + (!isEmpty(succesText) ? " active" : "")}>
        <div className="succes">
          <img src={succesImg} />
          <span>{succesText}</span>
        </div>
      </div>
    </div>
  );
};

type InputCertify = {
  label?: string;
  name?: string;
  type?: string;
  children?: any;
  number?: boolean;
  succesText?: string;
};

export const InputCertify = forwardRef(
  ({ label, name, type, number = false, succesText, children }: InputCertify, ref: any) => {
    return (
      <div className="cmap1010-input">
        <div className="title">{label}</div>
        <div className="input-wrap">
          <div className="input padding">
            <input
              ref={ref}
              type={type}
              name={name}
              placeholder="6자리 인증 번호"
              maxLength={6}
              {...(number && { "data-number": true })}
              autoComplete="one-time-code"
            />
            {children}
          </div>
        </div>
        <div className={"succes-wrap" + (!isEmpty(succesText) ? " active" : "")}>
          <div className="succes">
            <img src={succesImg} />
            <span>{succesText}</span>
          </div>
        </div>
      </div>
    );
  }
);
InputCertify.displayName = "InputCertify";
